import { Icon } from "@newsela/angelou";
import { CSSObject } from "@emotion/react";

import AiSparkIconSVG from "@/icons/AiSparkIcon/AiSparkIconSVG";
import { betaTagCss } from "./AIBetaTag.style";
interface AIBetaTagProps {
  enableHoverEffect?: boolean;
  text?: string;
  withIcon?: boolean;
  customCss?: CSSObject;
}

export const AIBetaTag = ({
  enableHoverEffect = false,
  text = "BETA",
  withIcon = false,
  customCss,
}: AIBetaTagProps) => {
  return (
    <span css={{ ...betaTagCss(enableHoverEffect), ...customCss }}>
      {text}
      {withIcon && (
        <Icon
          SvgComponent={AiSparkIconSVG}
          size={Icon.sizes.sm}
          isDecorative={false}
          title="Beta AI Tag"
        />
      )}
    </span>
  );
};

AIBetaTag.displayName = "AIBetaTag";

export default AIBetaTag;
